export default {
  common: {
    appName: 'ElderCare',
    loading: 'Laden...',
    retry: 'Opnieuw',
    goBack: 'Startpagina',
    logout: 'Uitloggen',
    save: 'Opslaan',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    search: 'Zoeken',
    weekDays: {
      sun: 'Zo',
      mon: 'Ma',
      tue: 'Di',
      wed: 'Wo',
      thu: 'Do',
      fri: 'Vr',
      sat: 'Za',
    },
  },
  nav: {
    home: 'Start',
    login: 'Inloggen',
    dashboard: 'Dashboard',
    health: 'Gezondheid',
    medication: 'Medicatie',
    sos: 'Nood',
    family: 'Familie',
    article: 'Artikelen',
    checkin: 'Check-in',
    settings: 'Instellingen',
    about: 'Over',
  },
  footer: {
    rights: 'Alle rechten voorbehouden',
    privacy: 'Privacybeleid',
    terms: 'Servicevoorwaarden',
  },
  index: {
    hero: {
      title: 'ElderCare - Slimme gezondheidsbewaker voor senioren',
      subtitle: 'Gezondheidsplatform ontworpen voor ouderen, houdt families op de hoogte en senioren gezond',
      cta: 'Beginnen',
      learnMore: 'Meer informatie',
    },
    features: {
      title: 'Kernfuncties',
      health: { title: 'Gezondheidsmonitoring', desc: 'Registreer bloeddruk, bloedsuiker en hartslag met slimme waarschuwingen' },
      medication: { title: 'Medicatiebeheer', desc: 'Herinneringen en interactiecontrole, vergeet nooit meer een dosis' },
      sos: { title: 'Noodoproep', desc: 'SOS met één aanraking, automatische familienotificatie en locatiedeling' },
      family: { title: 'Familiezorg', desc: 'Monitoring op afstand, directe waarschuwingen en gegevensdeling voor families' },
      article: { title: 'Gezondheidsartikelen', desc: 'Betrouwbare gezondheidskennis en gepersonaliseerde welzijngidsen' },
      checkin: { title: 'Dagelijkse check-in', desc: 'Eenvoudige dagelijkse tracking voor gezonde gewoonten' },
    },
    elderly: {
      title: 'Seniorenvriendelijk design',
      desc: 'Ontworpen voor senioren: makkelijk te gebruiken, zien en aanraken',
      font: 'Grote lettertypen',
      touch: 'Grote raakvlakken',
      contrast: 'Hoogcontrastkleuren',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Inloggen',
    registerTab: 'Registreren',
    name: 'Naam',
    email: 'E-mail',
    password: 'Wachtwoord',
    role: 'Ik ben',
    elderRole: 'Senior',
    familyRole: 'Familielid',
    bindCode: 'Koppelcode',
    bindCodeHint: 'Voer de koppelcode van het senioraccount in om te koppelen en gezondheidsgegevens te bekijken',
    loginBtn: 'Inloggen',
    registerBtn: 'Registreren',
    verifyHint: 'Na registratie wordt een verificatie-e-mail naar uw adres verzonden',
    error: 'Bewerking mislukt, probeer opnieuw',
    nameTooShort: 'Naam moet minimaal 2 tekens bevatten',
    emailInvalid: 'Voer een geldig e-mailadres in',
    passwordTooShort: 'Wachtwoord moet minimaal 8 tekens bevatten',
  },
  dashboard: {
    title: 'Gezondheidsdashboard',
    metrics: {
      bloodPressure: 'Bloeddruk',
      bloodSugar: 'Bloedsuiker',
      heartRate: 'Hartslag',
      weight: 'Gewicht',
      sleep: 'Slaap',
      temperature: 'Temperatuur',
    },
    quickActions: 'Snelle acties',
    recordHealth: 'Gezondheid registreren',
    takeMedicine: 'Medicatie innemen',
    sos: 'Noodoproep',
    checkinStatus: 'Check-in vandaag',
    checkedIn: 'Vandaag ingecheckd',
    notCheckedIn: 'Vandaag niet ingecheckd',
    goCheckin: 'Inchecken',
    medicationReminders: 'Medicatieherinneringen',
    noReminders: 'Geen medicatieherinneringen',
    taken: 'Ingenomen',
  },
  health: {
    title: 'Gezondheidsdossier',
    inputTitle: 'Gegevens invoeren',
    systolic: 'Systolisch (mmHg)',
    diastolic: 'Diastolisch (mmHg)',
    bloodSugar: 'Bloedsuiker (mmol/L)',
    heartRate: 'Hartslag (bpm)',
    weight: 'Gewicht (kg)',
    sleepHours: 'Slaap (uren)',
    temperature: 'Temperatuur (°C)',
    submit: 'Registratie verzenden',
    trend: 'Trends',
    days: 'dagen',
    aiAnalysis: 'AI-gezondheidsanalyse',
    analyze: 'Analyseren',
    noAnalysis: 'Klik op de bovenstaande knop voor een AI-gezondheidsanalyserapport',
    history: 'Geschiedenis',
    noHistory: 'Geen geschiedenis',
    chartLabelSystolic: 'Systolische druk',
  },
  medication: {
    title: 'Medicatiebeheer',
    currentPlan: 'Huidig plan',
    noMedications: 'Geen medicatie',
    addMedication: 'Medicatie toevoegen',
    name: 'Medicatienaam',
    dosage: 'Dosering',
    frequency: 'Frequentie',
    freqDaily: 'Eens per dag',
    freqTwice: 'Twee keer per dag',
    freqThree: 'Drie keer per dag',
    freqWeekly: 'Eens per week',
    time: 'Tijdstip',
    startDate: 'Startdatum',
    addBtn: 'Toevoegen',
    interactionWarning: 'Interactiewaarschuwing',
    noInteraction: 'Geen interactierisico\'s',
    calendar: 'Medicatiekalender',
    invalidTimeFormat: 'Ongeldig tijdformaat, gebruik HH:mm (bijv., 08:00, 20:00)',
  },
  sos: {
    title: 'Noodoproep',
    holdToCall: 'Vasthouden om te bellen',
    holdHint: 'Houd 1 seconde vast om de noodoproep te activeren',
    sent: 'Noodoproep verzonden',
    sentDesc: 'Uw noodcontacten zijn gewaarschuwd. Blijf kalm en wacht op hulp',
    contacts: 'Noodcontacten',
    location: 'Huidige locatie',
    loadingLocation: 'Locatie ophalen...',
    locationUnavailable: 'Locatie niet beschikbaar',
    history: 'SOS-geschiedenis',
    noHistory: 'Geen SOS-registraties',
    confirmed: 'Bevestigd',
    pending: 'In afwachting',
    sendFailed: 'Noodalert verzenden mislukt, probeer opnieuw',
    resolved: 'Opgelost',
  },
  family: {
    title: 'Familiezorg',
    members: 'Gekoppelde familie',
    noMembers: 'Geen gekoppelde familieleden',
    bindCode: 'Koppelcode',
    bindCodeHint: 'Deel deze code met familieleden om accounts te koppelen',
    invite: 'Familielid uitnodigen',
    email: 'E-mail familielid',
    relationship: 'Relatie',
    relSon: 'Zoon',
    relDaughter: 'Dochter',
    relSpouse: 'Echtgenoot',
    relSibling: 'Broer/Zus',
    relOther: 'Overig',
    inviteBtn: 'Uitnodiging versturen',
    notifications: 'Notificatievoorkeuren',
    prefAbnormal: 'Gezondheidsafwijking-melding',
    prefMedication: 'Medicatieherinnering',
    prefSos: 'Noodwaarschuwing',
    prefWeekly: 'Wekelijks rapport',
    prefCheckin: 'Check-in notificatie',
    dataSharing: 'Gegevensdeling',
    shareDesc: 'Familie toestaan uw gezondheidsgegevens te bekijken',
  },
  article: {
    title: 'Gezondheidsartikelen',
    search: 'Artikelen zoeken...',
    noArticles: 'Geen artikelen gevonden',
    expand: 'Lees meer',
    collapse: 'Inklappen',
    categories: {
      all: 'Alles',
      heart: 'Hart- en vaatziekten',
      diabetes: 'Diabetes',
      bone: 'Botten',
      sleep: 'Slaap',
      nutrition: 'Voeding',
      exercise: 'Beweging',
    },
  },
  checkin: {
    title: 'Dagelijkse check-in',
    feeling: 'Hoe voelt u zich vandaag?',
    feelings: {
      great: 'Uitstekend',
      good: 'Goed',
      normal: 'Normaal',
      bad: 'Slecht',
      terrible: 'Vreselijk',
    },
    medication: 'Medicatie vandaag',
    yes: 'Ja',
    no: 'Nee',
    diet: 'Dieetbeoordeling',
    dietRatings: {
      good: 'Goed',
      normal: 'Normaal',
      poor: 'Slecht',
    },
    exercise: 'Beweging vandaag',
    mood: 'Stemming',
    submit: 'Check-in verzenden',
    streak: 'Reeks',
    streakDays: 'dagen',
    calendar: 'Check-in kalender',
  },
  settings: {
    title: 'Instellingen',
    profile: 'Profiel',
    name: 'Gebruikersnaam',
    phone: 'Telefoon',
    birthday: 'Geboortedatum',
    emergencyContact: 'Noodcontact',
    save: 'Wijzigingen opslaan',
    preferences: 'Voorkeuren',
    language: 'Taal',
    theme: 'Thema',
    light: 'Licht',
    dark: 'Donker',
    notifications: 'Notificaties',
    notifHealth: 'Gezondheidswaarschuwingen',
    notifMedication: 'Medicatieherinneringen',
    notifSos: 'Noodwaarschuwingen',
    notifCheckin: 'Check-in herinneringen',
    bindCode: 'Mijn koppelcode',
    changePassword: 'Wachtwoord wijzigen',
    currentPassword: 'Huidig wachtwoord',
    newPassword: 'Nieuw wachtwoord',
    changePasswordBtn: 'Wachtwoord wijzigen',
    dangerZone: 'Gevarenzone',
    deleteDesc: 'Accountverwijdering is onomkeerbaar. Alle gegevens gaan verloren',
    deleteAccount: 'Account verwijderen',
    deleteConfirm: 'Weet u het zeker? Deze actie is onomkeerbaar!',
  },
  about: {
    title: 'Over ElderCare',
    subtitle: 'Slimme gezondheidsbewaker voor senioren',
    intro: 'Introductie',
    introContent: 'ElderCare is een gezondheidsplatform ontworpen voor senioren, met slimme monitoring, medicatiebeheer, noodoproepen en meer, om senioren te helpen hun gezondheid te beheren terwijl ze verbonden blijven met hun familie.',
    version: 'Versie-informatie',
    versionNumber: 'Versienummer',
    buildDate: 'Bouwdatum',
    acknowledgements: 'Dankbetuigingen',
    contact: 'Contact',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Privacybeleid',
    terms: 'Servicevoorwaarden',
  },
  notfound: {
    message: 'Sorry, de pagina die u zoekt bestaat niet',
    goHome: 'Naar startpagina',
  },
  privacy: {
    title: 'Privacybeleid',
    sections: {
      collection: {
        title: 'Informatiecollectie',
        content: 'We verzamelen alleen persoonlijke informatie die nodig is voor het leveren van onze diensten, waaronder registratiegegevens (e-mail, naam), gezondheidsgegevens (bloeddruk, bloedsuiker en andere indicatoren) en apparaatinformatie. We verzamelen geen persoonlijke informatie die niet gerelateerd is aan onze diensten.',
      },
      usage: {
        title: 'Gebruik van informatie',
        content: 'Uw persoonlijke informatie wordt uitsluitend gebruikt voor het leveren en verbeteren van onze diensten, waaronder gezondheidsgegevensanalyse, afwijkingswaarschuwingen, medicatieherinneringen en andere kernfuncties. We zullen uw informatie niet voor ongeautoriseerde doeleinden gebruiken.',
      },
      storage: {
        title: 'Opslag van informatie',
        content: 'Uw gegevens worden opgeslagen op beveiligde cloudservers met versleutelde verzending en opslag. We nemen redelijke technische maatregelen om de veiligheid van uw gegevens te beschermen en ongeautoriseerde toegang te voorkomen.',
      },
      sharing: {
        title: 'Delen van informatie',
        content: 'Zonder uw uitdrukkelijke toestemming delen wij uw persoonlijke informatie niet met derden. Gezondheidsgegevens worden alleen gedeeld met gekoppelde familieleden nadat u de familiekoppeling heeft geautoriseerd.',
      },
      rights: {
        title: 'Uw rechten',
        content: 'U heeft het recht om uw persoonlijke informatie in te zien, te corrigeren en te verwijderen, evenals uw toestemming in te trekken. U kunt deze rechten uitoefenen via de instellingen in de app of door contact op te nemen met ons ondersteuningsteam.',
      },
      security: {
        title: 'Beveiliging',
        content: 'We gebruiken versleuteling en beveiligingsmaatregelen conform de branche standaarden om uw gegevens te beschermen, waaronder SSL-versleutelde verzending, versleutelde gegevensopslag en toegangscontrole. We herzien en actualiseren regelmatig onze beveiligingsmaatregelen.',
      },
    },
  },
  terms: {
    title: 'Servicevoorwaarden',
    sections: {
      acceptance: {
        title: 'Acceptatie van voorwaarden',
        content: 'Door deze applicatie te gebruiken, gaat u akkoord met deze servicevoorwaarden. Als u het niet eens bent met enig deel van deze voorwaarden, stop dan met het gebruik van deze applicatie. We behouden ons het recht voor om deze voorwaarden te wijzigen.',
      },
      service: {
        title: 'Servicebeschrijving',
        content: 'ElderCare biedt gezondheidsmanagementondersteuning, waaronder gezondheidsgegevensregistratie, medicatieherinneringen, noodoproepen en andere functies. Deze service is alleen ter referentie en vormt geen medisch advies, noch kan het professionele medische diensten vervangen.',
      },
      accounts: {
        title: 'Accountbeheer',
        content: 'U moet een account registreren om de kernfuncties van deze applicatie te gebruiken. U bent verantwoordelijk voor de veiligheid van uw wachtwoord en alle activiteiten onder uw account. Als u ongeautoriseerd gebruik van uw account ontdekt, meld dit dan onmiddellijk aan ons.',
      },
      data: {
        title: 'Gegevens en privacy',
        content: 'We hechten veel waarde aan de bescherming van uw privacy. Raadpleeg ons Privacybeleid voor gedetailleerde regels over gegevensverwerking. U behoudt volledige controle over de gezondheidsgegevens die u indient.',
      },
      liability: {
        title: 'Aansprakelijkheidsbeperking',
        content: 'De gezondheidsinformatie die door deze applicatie wordt verstrekt, is alleen ter referentie en vormt geen medische diagnose of behandeladvies. We zijn niet aansprakelijk voor schade voortvloeiend uit het gebruik van informatie uit deze applicatie. Raadpleeg bij gezondheidsproblemen een gekwalificeerde zorgprofessional.',
      },
      changes: {
        title: 'Wijzigingen in voorwaarden',
        content: 'We kunnen deze servicevoorwaarden van tijd tot tijd bijwerken. Belangrijke wijzigingen worden meegedeeld via in-app notificaties of e-mail. Voortgezet gebruik van deze applicatie geldt als acceptatie van de bijgewerkte voorwaarden.',
      },
    },
  },
  feedback: {
    title: 'Feedback',
    subtitle: 'Uw feedback is erg belangrijk voor ons',
    name: 'Naam',
    namePlaceholder: 'Voer uw naam in (optioneel)',
    email: 'E-mail',
    emailPlaceholder: 'Voer uw e-mail in',
    subject: 'Onderwerp',
    subjectGeneral: 'Algemene feedback',
    subjectBug: 'Bugrapport',
    subjectFeature: 'Functiesuggestie',
    subjectOther: 'Overig',
    message: 'Bericht',
    messagePlaceholder: 'Beschrijf uw feedback in detail...',
    submit: 'Feedback verzenden',
    submitting: 'Bezig met verzenden...',
    success: 'Feedback succesvol verzonden! Bedankt voor uw bijdrage',
    error: 'Feedback verzenden mislukt, probeer het later opnieuw',
  },
  verify: {
    loading: 'Uw e-mail wordt geverifieerd...',
    success: 'Verificatie geslaagd!',
    successDesc: 'Uw e-mail is geverifieerd. U kunt nu inloggen',
    failed: 'Verificatie mislukt',
    failedDesc: 'De verificatielink is ongeldig of verlopen. Stuur de verificatie-e-mail opnieuw',
    resend: 'Verificatie-e-mail opnieuw verzenden',
    resending: 'Bezig met verzenden...',
    goLogin: 'Ga naar inloggen',
  },
  theme: {
    light: 'Licht',
    dark: 'Donker',
  },
}
